import { render, staticRenderFns } from "./RecommendationChip.vue?vue&type=template&id=63f9e378"
import script from "./RecommendationChip.vue?vue&type=script&lang=js"
export * from "./RecommendationChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports